export class ProductHandler {

    meta_field: HTMLInputElement;

    // max users
    message: HTMLElement;
    error_field: HTMLInputElement;
    company_id_field: HTMLInputElement;

    // defaults
    quantity_selector: HTMLElement;
    cart_button: HTMLElement;


    constructor() {
        this.init();
        this.validate();
        console.log(this);
    }

    init() {
        this.meta_field = document.querySelector('input[name="sta_custom[meta]"]');
        this.error_field = document.querySelector('input[name="sta_custom[error]"]');
        this.company_id_field = document.querySelector('input[name="sta_custom[company_id]"]');
        this.message = document.querySelector('.sta-message');
        this.quantity_selector = document.querySelector('form.cart .quantity');
        this.cart_button = document.querySelector('form.cart .single_add_to_cart_button');
    }

    validate() {
        if (this.meta_field && this.meta_field.value === 'max_users') {
            this.validate_max_users();
        }
    }

    validate_max_users() {
        let error = parseInt(this.error_field?.value);
        let company_id = this.company_id_field?.value;
        console.log(error, company_id);

        if (error || !company_id) {
            if (this.quantity_selector) {
                this.quantity_selector.style.display = 'none';
            }
            if (this.cart_button) {
                this.cart_button.style.display = 'none';
            }
            this.message.innerHTML = `<span style="color: #fed03d">Derzeit ist dieses Produkt nicht verfügbar. Bitte beachten Sie, dass nur angemeldete Benutzer dieses Produkt kaufen können.</span>`;
        }
    }

}